import {makeStyles, Typography} from "@material-ui/core";
import {useState} from "react";
import {useSelector} from "react-redux";
import {RootState} from '../../../store';
import {defaultWidth, heightUnit, padGinUnit, widthUnit, fontUnit} from "../../../utils/DeviceManager";
// @ts-ignore
import CurrencyInput from "react-currency-input";
import { AcnColorTheme } from "../../../assets/css/AcnColorTheme";
// import CurrencyInputOld from "react-currency-input-field";

interface PaymentCard {
    title: string;
    amount: string;
    callBack: any;
}

export function PaymentCustomCard(props: PaymentCard) {
    const classes = useStyles();
    const {title, amount} = props;
    const [customAmount, setCustomAmount] = useState(amount)
    // const [selectAll, setSelectAll] = useState(true)
    const [errorText, setErrorText] = useState("")

    const [billInfo] = useSelector((state: RootState) => [
        state.billerReducer.billInfo,
    ]);

    const dynamicFont = (num: number) => {
        // const lng = amount.length
        const lng = String(customAmount).length
        if (lng <= 7) return num
        const lvl = (defaultWidth * 0.052);
        if (lvl >= num) return num
        return lvl
    }
    
    console.log(customAmount, typeof(customAmount));
    
    
    // ==================== Fix Autofocus Solution: 1 ========================
    let componentDidMount_super = CurrencyInput.prototype.componentDidMount;
    CurrencyInput.prototype.componentDidMount = function() {
        if(!this.props.autoFocus) {
            let setSelectionRange_super = this.theInput.setSelectionRange;
            this.theInput.setSelectionRange = () => {};
            // @ts-ignore
            componentDidMount_super.call(this, ...arguments);
            this.theInput.setSelectionRange = setSelectionRange_super;
        }
        else {
            // @ts-ignore
            componentDidMount_super.call(this, ...arguments);
        }
    };
    let componentDidUpdate_super = CurrencyInput.prototype.componentDidUpdate;
    CurrencyInput.prototype.componentDidUpdate = function() {
        if(!this.props.autoFocus) {
            let setSelectionRange_super = this.theInput.setSelectionRange;
            this.theInput.setSelectionRange = () => {};
            // @ts-ignore
            componentDidUpdate_super.call(this, ...arguments);
            this.theInput.setSelectionRange = setSelectionRange_super;
        }
        else {
            // @ts-ignore
            componentDidMount_super.call(this, ...arguments);
        }
    };
    // ========================== End of Solution 1 ===========================

    return (
        <div  className={classes.rectangle2} onClick={() => { props.callBack(customAmount) }}>
            <div className={classes.rectangle1}>
                <Typography className={classes.content}>
                    {title} 
                </Typography>
                <Typography className={classes.content2}>
                    <CurrencyInput
                        id={"input-amount-" + amount}
                        name={"input-mount-name-" + amount}
                        inputType="text"
                        placeholder=""
                        className={classes.inputCustom}
                        style={{fontSize: dynamicFont(32), height: heightUnit(72), minHeight: '50px', maxWidth: widthUnit(defaultWidth * 0.52), width: widthUnit(defaultWidth * 0.52),
                            minWidth: widthUnit(200), textAlign: "end", paddingRight: padGinUnit(0)}}
                        value={customAmount}
                        precision="2"
                        autofocus={false}
                        allowNegative={false}
                        selectAllOnFocus
                        // @ts-ignore
                        onChange={(value, name) => {
                            // setCustomAmount(value? value.replace(/,/g, "") : "0.00")
                            // props.callBack(value? value.replace(/,/g, "") : "0.00")
                            if (value && value.length<14){
                                let cleanValue = String(value).replace(/,/g, "")                                
                                setCustomAmount(cleanValue)
                                props.callBack(cleanValue)
                            } else {
                                setCustomAmount(customAmount)
                                props.callBack(customAmount)
                            }
                            // console.log(customAmount, typeof(customAmount));
                            // console.log("customAmount, type, length: " + customAmount, typeof(customAmount), customAmount.length);
                            // console.log("value, type, length: " + value, typeof(value), value.length)
                            // console.log("name, type, length: " + name, typeof(name), name.length)
                            // console.log("-----------------------------------------------")
                            // @ts-ignore
                            const intValue = Number(value === '' ? "0" : value)
                            if (intValue < Number(billInfo.minimumAmount)) {
                                if (billInfo.loanType.startsWith("TL")){
                                    setErrorText("*ชำระต่ำกว่าค่างวดตามสัญญา อาจมีค่าปรับ")
                                } else {
                                    setErrorText("*ชำระต่ำกว่าขั้นต่ำ อาจมีค่าปรับ")
                                }
                            } else {
                                setErrorText("")
                            }
                        }}
                    />
                    {/* <CurrencyInputOld
                        id="input-amount"
                        name="input-mount-name"
                        placeholder="0.00"
                        className={classes.inputCustom}
                        style={{fontSize: dynamicFont(32), height: heightUnit(72), maxWidth: widthUnit(defaultWidth * 0.52), width: widthUnit(defaultWidth * 0.52),
                            minWidth: widthUnit(200), textAlign: "end", paddingRight: padGinUnit(0)}}
                        defaultValue={customAmount}
                        decimalsLimit={2}
                        allowNegativeValue={false}
                        onValueChange={(value, name) => {
                            setCustomAmount(value? value : "0.00")
                            props.callBack(value? value : "0.00")
                            console.log(value, name)
                            // @ts-ignore
                            const intValue = parseInt(value === '' ? "0" : value)
                            if (intValue < billInfo.minimumAmount) {
                                if (billInfo.loanType.startsWith("TL")){
                                    setErrorText("*จ่ายต่ำกว่าค่างวดตามสัญญา อาจมีค่าปรับ")
                                } else {
                                    setErrorText("*จ่ายต่ำกว่าขั้นต่ำ อาจมีค่าปรับ")
                                }
                            } else {
                                // setErrorText("*จ่ายต่ำกว่าค่างวดตามสัญญา อาจมีค่าปรับ")
                                setErrorText("")
                            }
                        }}
                    /> */}
                </Typography>
            </div>
            {
                errorText.length >0 ?
                    <Typography className={classes.errortext} align={"left"}>
                        {errorText}
                    </Typography> : <div/>
            }

        </div>
    )
}


const useStyles = makeStyles({
        rectangle1: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: '16px',
            alignItems: 'center',
        },
        rectangle2: {
            alignItems: 'center',
            background: AcnColorTheme.white,
            borderRadius: '8px',
            boxSizing: 'border-box',
            margin: '8px 0',
            border: '2px solid #DADDDF',
            minHeight: '76px',
            '&:hover': {
                border: '2px solid #F5333F',
                background: AcnColorTheme.white,
            }
        },
        inputCustom: {
            
            borderRadius: '0px',
            boxSizing: 'border-box',
            borderLeft: '0px solid #000000',
            borderRight: '0px solid #000000',
            borderTop: '0px solid #000000',
            borderBottom: '2px solid #000000',
            '&:hover': {
                borderRadius: '0px',
                borderLeft: '0px solid #48A7FF',
                borderRight: '0px solid #48A7FF',
                borderTop: '0px solid #48A7FF',
                borderBottom: '2px solid #48A7FF'
            },
            '&:focus': {
                borderRadius: '0px',
                borderLeft: '0px solid #48A7FF',
                borderRight: '0px solid #48A7FF',
                borderTop: '0px solid #48A7FF',
                borderBottom: '2px solid #48A7FF'
            },
        },
        content: {
            padding: '8px',
            fontFamily: 'Thonburi',
            fontSize: 18,
            fontWeight: 'bold'
        },
        content2: {
            fontWeight: 'normal',
            padding: '8px'
        },
        fee: {
            fontSize: '14px',
            color: AcnColorTheme.darkGrey,
        },
        img: {
            width: '40px',
            height: '40px',
            borderRadius: ' 50%',

        },
        errortext: {
            width: "100%",
            paddingLeft: 8,
            paddingBottom: 8,
            fontSize: fontUnit(14),
            fontFamily: "Thonburi", 
            fontWeight: 'bold',
            alignContent: "flex-start",
            color: AcnColorTheme.black,
        }
    },
    {name: 'PaymentCard'});